import { render, staticRenderFns } from "./CookiesTemplate.vue?vue&type=template&id=a77135d0&scoped=true&"
import script from "./CookiesTemplate.vue?vue&type=script&lang=js&"
export * from "./CookiesTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CookiesTemplate.vue?vue&type=style&index=0&id=a77135d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77135d0",
  null
  
)

export default component.exports